import React from "react";
import { SKILLS } from "@/data/portfolio";

export const Skills = () => {
  const entries = Object.entries(SKILLS);
  return (
    <section id="skills" data-testid="skills-section" className="bg-background">
      <div className="max-w-3xl mx-auto px-6 py-10">
        <hr className="rule" />
        <h2 className="font-serif text-2xl md:text-3xl text-foreground mb-6">
          Skills
        </h2>

        <dl className="space-y-4">
          {entries.map(([category, list]) => (
            <div
              key={category}
              data-testid={`skill-cat-${category
                .toLowerCase()
                .replace(/[^a-z0-9]+/g, "-")}`}
              className="grid grid-cols-1 sm:grid-cols-4 gap-2 sm:gap-4 py-2 border-b border-border last:border-b-0"
            >
              <dt className="font-serif text-base text-foreground sm:col-span-1 small-caps">
                {category}
              </dt>
              <dd className="text-base text-foreground/85 sm:col-span-3 leading-relaxed">
                {list.join(", ")}
              </dd>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
};
